module.exports = __webpack_public_path__ + "static/media/profile3.da3849c1.png";